module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVAgMAAAAPwucnAAAADFBMVEUAAAD/IWH/IWH/ImHc2wBZAAAAA3RSTlMAgL+aK/KIAAAALUlEQVQI12MoYWBg+AvE9Q4MDPIXGBjYvzAwMGIV2A+iQXyQOEgejQs2B2QeAPvhEj58Jtp5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/tixbay-entry-right-icon.png
// module id = 2033
// module chunks = 148